import { Component, OnInit, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Route, ActivatedRoute } from '@angular/router';
import { TimeRecordService } from 'src/app/modules/daily-time-record/services/time-record/time-record.service';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { SidebarService } from 'src/app/modules/core/services/sidebar/sidebar.service';

@Pipe({name: 'timePipe'})
export class TimePipe implements PipeTransform {
  transform(value: any): any {
    if(value) {
      let hour = (value.split(':'))[0];
      let min = (value.split(':'))[1];
      let part = hour > 12 ? 'PM' : 'AM';
      min = (min+'').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour+'').length == 1 ? `0${hour}` : hour;
      return `${hour}:${min} ${part}`
    }
  }
}

const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
  },
};

@Component({
  selector: 'ark-daily-time-record',
  templateUrl: './daily-time-record.component.html',
  styleUrls: ['./daily-time-record.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class DailyTimeRecordComponent implements OnInit, OnDestroy {

  months = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' },
  ];
  isNoResult: boolean = true;
  isSidebarMinimized: boolean = false;
  today = new Date(); 
  formGroup: FormGroup;
  id = null;
  name = null;
  clinic = null;
  records = null;
  selectedYear = +moment().format("YYYY");
  selectedMonth = +moment().format("M");

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private record: TimeRecordService,
    private auth: AuthService,
    private sidebarService: SidebarService
  ) { 
    this.clinic = this.auth.getAuthUser().user_clinic.id;
    this.route.params.subscribe(param => {
      this.id = param.id
    });
    if(localStorage.getItem('isSidebarMinimized')) {
      this.isSidebarMinimized = JSON.parse(localStorage.getItem('isSidebarMinimized'));
    }
    this.sidebarService.sidebarState.subscribe((nextValue) => {
      this.isSidebarMinimized = nextValue
    });
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      month: [''],
      year: new FormControl(moment()),
    });
    this.formGroup.get('month').setValue(this.selectedMonth);
    this.name = localStorage.getItem('assistantName');
    this.getTimeRecords();
  }

  ngOnDestroy() {
    localStorage.removeItem('assistantName');
  }

  goBackToEmployees() {
    history.go(-1);
  }

  chosenYearHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    const val = this.formGroup.value.year;
    val.year(normalizedYear.year());
    this.formGroup.get('year').setValue(val);
    datepicker.close();

    this.selectedYear = +moment(this.formGroup.value.year).format("YYYY");
    this.getTimeRecords();
  }

  getMonth(val) {
    this.formGroup.get('month').setValue(val.value);
    this.selectedMonth = val.value;
    this.getTimeRecords();
  }

  getTimeRecords() {
    this.record.getTimeRecords(this.clinic, this.id, this.selectedMonth, this.selectedYear).subscribe(res => {
      if(res.length > 0) {
        this.isNoResult = false;
        this.records = res;
      } else {
        this.isNoResult = true;
      }
    });
  }
}
